import { useEffect, useState } from 'react'

const STORAGE_KEY = 'mds-offer-deadline'

function getDeadline(hours: number): number {
  const fallback = Date.now() + hours * 3600 * 1000
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY)
    if (stored) {
      const value = Number(stored)
      if (!Number.isNaN(value)) return value
    }
    window.localStorage.setItem(STORAGE_KEY, String(fallback))
  } catch {
    // localStorage no disponible: usamos la duración desde ahora
  }
  return fallback
}

export function useCountdown(hours: number) {
  const [deadline] = useState(() => getDeadline(hours))
  const [remaining, setRemaining] = useState(() => Math.max(0, deadline - Date.now()))

  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(Math.max(0, deadline - Date.now()))
    }, 1000)
    return () => window.clearInterval(id)
  }, [deadline])

  const totalSeconds = Math.floor(remaining / 1000)
  return {
    hours: Math.floor(totalSeconds / 3600),
    minutes: Math.floor((totalSeconds % 3600) / 60),
    seconds: totalSeconds % 60,
  }
}
